module.exports = __webpack_public_path__ + "static/media/skype.9b79ccfa.svg";